import RopTable, { TableItem, TableRowType } from "../../../../main/components/RopTable/RopTable";
import { FalhasCriticasAtivas } from "../../types";

export default function FalhasCriticasAtivasTable(props: {
    falhasCriticasAtivas: FalhasCriticasAtivas[];
    alarmDescriptionByCode: Record<string, string>;
}) {
    const { falhasCriticasAtivas, alarmDescriptionByCode } = props;

    const allAlarmCodes = Array.from(
        new Set(
            falhasCriticasAtivas.flatMap((usina) =>
                usina.falhasPorAlarmeCode?.map((falha) => falha.alarmCode)
            )
        )
    ).sort();

    const tableRows: TableRowType[] | undefined = falhasCriticasAtivas.map((usina) => {
        const rowItems: TableItem[] = [
            {
                item: <>{usina.usinaCode}</>,
                align: "center",
            },
            ...allAlarmCodes.map((alarmCode) => {
                const falha = usina.falhasPorAlarmeCode?.find(
                    (f) => f.alarmCode === alarmCode
                );
                const quantidade = falha ? falha.quantidadeDeFalhas : 0;
                return {
                    item: <>{quantidade > 0 ? quantidade : "-"}</>,
                    align: "center" as const,
                };
            }),
        ];

        return { rowItems };
    });

    // monta os headers (2 linhas simuladas no header)
    const itemsHeaders: TableItem[] = [
        { item: "USINA", align: "center" },
        ...allAlarmCodes.map((alarmCode) => ({
            item: alarmCode,
            align: "center" as const,
        })),
    ];

    const itemsSubHeaders: TableItem[] = [
        { item: "", align: "center" },
        ...allAlarmCodes.map((alarmCode) => ({
            item: alarmDescriptionByCode[alarmCode ?? ""] || alarmCode,
            align: "center" as const,
        })),
    ];

    return (
        <RopTable
            sxCardBox={{
                height: "100%",
                width: "100%",
                minHeight: "400px",
                display: "flex",
                flexDirection: "column",
                margin: "0px",
            }}
            itemRows={tableRows}
            itemsHeaders={itemsHeaders}
            itemsSubHeaders={itemsSubHeaders}
        />
    );
}